document.addEventListener('DOMContentLoaded', function() {
  
  const carousels = document.querySelectorAll('.joe-five-slider_container');

  // 创建视口观察器
  const carouselObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 当轮播图进入视口时，初始化该轮播图
        // 初始化后取消观察此轮播图
        robustInitCarousel(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '600px', // 提前600px开始加载
    threshold: 0.05     // 当5%的元素可见时触发
  });
  
  // 开始观察所有轮播图
  carousels.forEach(carousel => {
    carouselObserver.observe(carousel);
  });

  function robustInitCarousel(carousel, tryCount = 0) {
      // 已初始化就别再干了
      if (carousel._inited) return;

      const itemsContainer = carousel.querySelector('.joe-five-slider_items');
      if (!itemsContainer) return;

      const items = itemsContainer.querySelectorAll('.joe-five-slider_item');

      if (items.length > 0) {
        // 真正初始化
        if (window.innerWidth >= 678) {
          pcCarousel(carousel);
        } else {
          mobileCarousel(carousel);
        }

        // 标记已初始化
        carousel._inited = true;
        tryCount = 50;

        // 如果之前排过重试定时器，清掉
        if (carousel._retryTimer) {
          clearTimeout(carousel._retryTimer);
          carousel._retryTimer = null;
        }
        return;
      }

      // 还没准备好：安排下一次重试（最多 50 次）
      if (tryCount < 50) {
        // 先清掉旧的（避免并发多个定时器）
        if (carousel._retryTimer) clearTimeout(carousel._retryTimer);
        carousel._retryTimer = setTimeout(() => {
          robustInitCarousel(carousel, tryCount + 1);
        }, 100);
      }
    }

  function pcCarousel(container) {
    // 基础元素
    const itemsContainer = container.querySelector('.joe-five-slider_items');
    const prevButton = container.querySelector('.joe-five-slider_prev');
    const nextButton = container.querySelector('.joe-five-slider_next');
    const navBar = container.querySelector('.joe-five-slider_nav-bar');
    const autoplayTime = parseInt(itemsContainer.getAttribute('data-auto')) || 4000;
    
    if (!itemsContainer) return;
    
    // 保存原始项目
    const originalItems = Array.from(container.querySelectorAll('.joe-five-slider_item'));
    if (originalItems.length === 0) return;
    
    // 设备检测
    const isDesktop = window.innerWidth >= 769;
    
    // 轮播配置
    const config = {
      itemCount: originalItems.length,
      activeIndex: originalItems.findIndex(item => item.classList.contains('slider_active')),
      autoplayTimer: null,
      resumeTimeout: null,            // 恢复自动轮播的定时器
      resumeDelay: 5000,              // 用户交互后恢复自动轮播的延迟时间(ms)
      transitionDuration: 400,        // 过渡时间(ms)
      autoplayDelay: autoplayTime,    // 自动轮播间隔(ms)
      frontBufferSize: isDesktop ? 5 : 3,
      backBufferSize: isDesktop ? 5 : 3,
      minVisibleCount: isDesktop ? 7 : 3,
      
      // 状态管理配置
      flowState: 'IDLE',      // 当前流程状态: IDLE, SLIDING, CLONING, WAITING
      slideCount: 0,          // 滑动计数
      batchThreshold: 3,      // 批量更新阈值
      clickQueue: [],         // 点击队列，存储用户的点击意图
      isProcessingQueue: false, // 是否正在处理队列
      currentDirection: null,  // 当前滑动方向: 'prev' 或 'next'
      isAutoplayPaused: false  // 是否暂停自动轮播
    };
    
    // 设置默认激活项
    if (config.activeIndex === -1) {
      config.activeIndex = Math.min(2, config.itemCount - 1);
    }
    
    // 初始化
    setupSlider();
    
    // 绑定事件
    prevButton.addEventListener('click', () => {
      pauseAutoplay();
      queueSlideAction('prev');
      resumeAutoplayAfterDelay();
    });
    
    nextButton.addEventListener('click', () => {
      pauseAutoplay();
      queueSlideAction('next');
      resumeAutoplayAfterDelay();
    });
    
    // 将滑动操作添加到队列
    function queueSlideAction(direction) {
      // 添加到队列
      config.clickQueue.push(direction);
      
      // 如果当前没有处理队列，开始处理
      if (!config.isProcessingQueue) {
        processQueue();
      }
    }
    
    // 处理队列中的滑动请求
    function processQueue() {
      // 如果队列为空或者当前不是IDLE状态，直接返回
      if (config.clickQueue.length === 0 || config.flowState !== 'IDLE') {
        config.isProcessingQueue = false;
        return;
      }
      
      config.isProcessingQueue = true;
      
      // 从队列中取出第一个操作
      const direction = config.clickQueue.shift();
      config.currentDirection = direction;
      
      // 更新索引
      if (direction === 'prev') {
        config.activeIndex = (config.activeIndex - 1 + config.itemCount) % config.itemCount;
      } else {
        config.activeIndex = (config.activeIndex + 1) % config.itemCount;
      }
      
      // 开始执行滑动流程
      executeSlideFlow(direction);
    }
    
    // 执行滑动流程
    function executeSlideFlow(direction) {
      // 设置状态为滑动中
      config.flowState = 'SLIDING';
      
      // 增加滑动计数
      config.slideCount++;
      
      // 获取当前项目
      const items = Array.from(itemsContainer.children);
      const activeItem = itemsContainer.querySelector('.slider_active');
      const activeIndex = items.indexOf(activeItem);
      
      // 确定新的激活项
      let newActiveIndex;
      
      if (direction === 'prev') {
        newActiveIndex = activeIndex - 1;
        
        // 预先添加更多项目到前面以确保平滑过渡
        if (newActiveIndex < config.frontBufferSize) {
          // 在前面添加2个额外项目
          for (let i = 0; i < 2; i++) {
            const firstItem = items[0];
            const firstIndex = parseInt(firstItem.getAttribute('data-index'));
            const newIndex = (firstIndex - 1 - i + config.itemCount) % config.itemCount;
            const newItem = createItem(newIndex);
            newItem.classList.add('front-buffer');
            newItem.style.opacity = '0'; // 先隐藏新项目
            
            itemsContainer.insertBefore(newItem, firstItem);
            
            // 淡入新项目
            setTimeout(() => {
              newItem.style.opacity = '1';
            }, 50);
          }
          
          // 更新新的激活索引（因为添加了2个新项目）
          newActiveIndex += 2;
        }
      } else {
        newActiveIndex = activeIndex + 1;
        
        // 预先添加更多项目到后面以确保平滑过渡
        if (items.length - newActiveIndex <= config.backBufferSize) {
          // 在后面添加2个额外项目
          for (let i = 0; i < 2; i++) {
            const lastItem = items[items.length - 1];
            const lastIndex = parseInt(lastItem.getAttribute('data-index'));
            const newIndex = (lastIndex + 1 + i) % config.itemCount;
            const newItem = createItem(newIndex);
            newItem.classList.add('back-buffer');
            newItem.style.opacity = '0'; // 先隐藏新项目
            
            itemsContainer.appendChild(newItem);
            
            // 淡入新项目
            setTimeout(() => {
              newItem.style.opacity = '1';
            }, 50);
          }
        }
      }
      
      // 设置新的激活状态（确保只有一个激活项）
      ensureSingleActiveItem(newActiveIndex);
      
      // 更新项目类型标记
      updateItemTypes(newActiveIndex);
      
      // 更新导航条
      updateNavBar();
      
      // 执行平滑滚动
      setTimeout(() => {
         // 增加延迟以确保DOM完全更新后再居中
          // 注意：对prev方向使用更长的延迟
          setTimeout(() => {
            centerActiveItem(true);
          }, direction === 'prev' ? 80 : 50);
        
        // 滑动阶段完成，检查是否需要进入增删阶段
        setTimeout(() => {
          if (config.slideCount >= config.batchThreshold) {
            // 需要执行增删克隆体
            config.flowState = 'CLONING';
            batchUpdateClones();
          } else {
            // 不需要增删，直接进入等待状态
            config.flowState = 'WAITING';
            // 短暂等待后回到IDLE状态
            setTimeout(() => {
              config.flowState = 'IDLE';
              // 继续处理队列中的请求
              processQueue();
            }, 300);
          }
        }, config.transitionDuration + 50);
      }, 50);
    }
    
    // 批量更新克隆体
    function batchUpdateClones() {
      console.log("执行批量克隆体增删...");
      
      // 禁用平滑滚动
      itemsContainer.style.scrollBehavior = 'auto';
      
      // 执行清理操作
      cleanupItems();
      
      // 标记这一阶段完成
      setTimeout(() => {
        // 恢复平滑滚动
        itemsContainer.style.scrollBehavior = 'smooth';
        
        // 重置计数
        config.slideCount = 0;
        
        // 转换到等待状态
        config.flowState = 'WAITING';
        
        // 短暂等待后回到IDLE状态
        setTimeout(() => {
          config.flowState = 'IDLE';
          // 恢复自动轮播（如果没有被暂停）
          if (!config.isAutoplayPaused) {
            startAutoplay();
          }
          // 继续处理队列
          processQueue();
        }, 300);
      }, 300);
    }
    
    // 初始化轮播器
    function setupSlider() {
      // 清空容器
      itemsContainer.innerHTML = '';
      
      const visibleCount = config.minVisibleCount;
      const frontBuffer = config.frontBufferSize;
      const backBuffer = config.backBufferSize;
      const totalCount = visibleCount + frontBuffer + backBuffer;
      
      const centerOffset = Math.floor(visibleCount / 2);
      const startIndex = (config.activeIndex - centerOffset - frontBuffer + config.itemCount) % config.itemCount;
      
      // 创建所有项目
      for (let i = 0; i < totalCount; i++) {
        const itemIndex = (startIndex + i + config.itemCount) % config.itemCount;
        const item = createItem(itemIndex);
        
        // 标记项目类型
        if (i < frontBuffer) {
          item.classList.add('front-buffer');
        } else if (i >= frontBuffer + visibleCount) {
          item.classList.add('back-buffer');
        } else {
          item.classList.add('visible-item');
        }
        
        itemsContainer.appendChild(item);
      }
      
      // 设置激活项（确保只有一个激活项）
      ensureSingleActiveItem(frontBuffer + centerOffset);
      
      // 初始滚动位置
      setTimeout(() => {
        centerActiveItem(false);
        updateNavBar();
      }, 10);
      
      // 设置初始状态
      config.flowState = 'IDLE';
      config.slideCount = 0;
      config.clickQueue = [];
      config.isProcessingQueue = false;
      config.isAutoplayPaused = false;
      
      // 开始自动轮播
      startAutoplay();
    }
    
    // 确保只有一个激活项
    function ensureSingleActiveItem(activeItemIndex) {
      // 清除所有激活状态
      const allItems = Array.from(itemsContainer.children);
      allItems.forEach(item => item.classList.remove('slider_active'));
      
      // 设置新的激活项
      if (typeof activeItemIndex === 'number') {
        if (allItems[activeItemIndex]) {
          allItems[activeItemIndex].classList.add('slider_active');
        }
      } else if (activeItemIndex instanceof Element) {
        activeItemIndex.classList.add('slider_active');
      }
      
      // 验证激活项数量（调试用）
      const activeItems = itemsContainer.querySelectorAll('.slider_active');
      if (activeItems.length !== 1) {
        console.warn(`警告: 发现 ${activeItems.length} 个激活项!`);
      }
    }
    
    // 创建轮播项
    function createItem(index) {
      // 克隆原始项目
      const original = originalItems[index];
      const clone = original.cloneNode(true);
      
      // 添加数据属性便于跟踪
      clone.setAttribute('data-index', index);
      clone.setAttribute('data-clone', 'true');
      
      // 重要：确保克隆项不带有激活状态
      clone.classList.remove('slider_active');
      
      return clone;
    }
    
    // 将激活项目居中
    function centerActiveItem(animate = true) {
      const activeItem = itemsContainer.querySelector('.slider_active');
      if (!activeItem) return;
      
      const containerWidth = itemsContainer.offsetWidth;
      const itemWidth = activeItem.offsetWidth;
      
      // 计算理想的滚动位置，让激活项居中
      const scrollLeft = activeItem.offsetLeft - (containerWidth - itemWidth) / 2;
      
      // 执行滚动
      itemsContainer.scrollTo({
        left: Math.max(0, scrollLeft),
        behavior: animate ? 'smooth' : 'auto'
      });
    }
    
    // 更新项目类型标记
    function updateItemTypes(activeIndex) {
      const items = Array.from(itemsContainer.children);
      
      items.forEach((item, index) => {
        item.classList.remove('front-buffer', 'visible-item', 'back-buffer');
        
        if (index < activeIndex - Math.floor(config.minVisibleCount / 2)) {
          item.classList.add('front-buffer');
        } else if (index > activeIndex + Math.floor(config.minVisibleCount / 2)) {
          item.classList.add('back-buffer');
        } else {
          item.classList.add('visible-item');
        }
      });
    }
    
    // 清理多余项目，保持适当数量
    function cleanupItems() {
      const items = Array.from(itemsContainer.children);
      const activeItem = itemsContainer.querySelector('.slider_active');
      if (!activeItem) return;
      
      // 记录清理前激活项的相对偏移，用于之后补偿 scrollLeft，避免“断层”
      const prevActiveOffset = activeItem.offsetLeft;
      
      const activeIndex = items.indexOf(activeItem);
      
      // 保留激活项前后的缓冲区和可见项目
      const keepStart = Math.max(0, activeIndex - config.frontBufferSize - 2);
      const keepEnd = Math.min(items.length - 1, activeIndex + config.backBufferSize + 2);
      
      // 计算要移除的项目
      const removeStart = items.slice(0, keepStart);
      const removeEnd = items.slice(keepEnd + 1);
      
      // 批量移除项目（不移除激活项）
      [...removeStart, ...removeEnd].forEach(item => {
        if (item.classList.contains('slider_active')) return;
        if (item.parentNode === itemsContainer) item.remove();
      });
      
      // 使用最新集合进行补足
      let currentItems = Array.from(itemsContainer.children);
      let currentActiveIndex = currentItems.indexOf(activeItem);
      
      // 确保前面有足够的缓冲项目
      if (currentActiveIndex < config.frontBufferSize) {
        const neededFront = config.frontBufferSize - currentActiveIndex;
        for (let i = 0; i < neededFront; i++) {
          currentItems = Array.from(itemsContainer.children);
          const firstIndex = parseInt(currentItems[0].getAttribute('data-index'));
          const newIndex = (firstIndex - 1 + config.itemCount) % config.itemCount;
          const newItem = createItem(newIndex);
          newItem.classList.add('front-buffer');
          itemsContainer.insertBefore(newItem, currentItems[0]);
        }
      }
      
      // 重新计算一次
      currentItems = Array.from(itemsContainer.children);
      currentActiveIndex = currentItems.indexOf(activeItem);
      
      // 确保后面有足够的缓冲项目
      const afterActive = currentItems.length - currentActiveIndex - 1;
      if (afterActive < config.backBufferSize) {
        const neededBack = config.backBufferSize - afterActive;
        for (let i = 0; i < neededBack; i++) {
          currentItems = Array.from(itemsContainer.children);
          const lastIndex = parseInt(currentItems[currentItems.length - 1].getAttribute('data-index'));
          const newIndex = (lastIndex + 1) % config.itemCount;
          const newItem = createItem(newIndex);
          newItem.classList.add('back-buffer');
          itemsContainer.appendChild(newItem);
        }
      }
      
      // 补偿滚动，让激活项保持原位置，避免可视跳动
      const newActiveOffset = activeItem.offsetLeft;
      itemsContainer.scrollLeft += (newActiveOffset - prevActiveOffset);
      
      // 再次确保只有一个激活项（以防万一）
      ensureSingleActiveItem(activeItem);
      
      // 使用最新的索引更新可见区域标记，确保激活项拥有 visible-item
      const updatedItems = Array.from(itemsContainer.children);
      const updatedActiveIndex = updatedItems.indexOf(activeItem);
      updateItemTypes(updatedActiveIndex);
    }
    
    // 更新导航条
    function updateNavBar() {
      if (!navBar) return;
      
      const navParent = navBar.parentElement;
      if (!navParent) return;
      
      const navWidth = navParent.offsetWidth;
      const barWidth = navWidth / config.itemCount;
      
      navBar.style.transition = 'left 0.3s ease';
      navBar.style.width = `${barWidth}px`;
      navBar.style.left = `${config.activeIndex * barWidth}px`;
    }
    
    // 开始自动轮播
    function startAutoplay() {
      stopAutoplay();
      config.autoplayTimer = setInterval(() => {
        if (config.flowState === 'IDLE' && !config.isAutoplayPaused) {
          queueSlideAction('next');
        }
      }, config.autoplayDelay);
    }
    
    // 停止自动轮播
    function stopAutoplay() {
      if (config.autoplayTimer) {
        clearInterval(config.autoplayTimer);
        config.autoplayTimer = null;
      }
    }
    
    // 暂停自动轮播
    function pauseAutoplay() {
      config.isAutoplayPaused = true;
      // 清除恢复自动轮播的定时器
      if (config.resumeTimeout) {
        clearTimeout(config.resumeTimeout);
        config.resumeTimeout = null;
      }
    }
    
    // 在一段时间后恢复自动轮播
    function resumeAutoplayAfterDelay() {
      // 清除现有恢复定时器
      if (config.resumeTimeout) {
        clearTimeout(config.resumeTimeout);
      }
      
      // 设置新的恢复定时器
      config.resumeTimeout = setTimeout(() => {
        config.isAutoplayPaused = false;
      }, config.resumeDelay);
    }
    
    // 窗口调整大小处理
    window.addEventListener('resize', debounce(() => {
      const newIsDesktop = window.innerWidth >= 769;
      if (newIsDesktop !== isDesktop) {
        // 屏幕类型改变，更新配置并重建轮播器
        config.frontBufferSize = newIsDesktop ? 5 : 3;
        config.backBufferSize = newIsDesktop ? 5 : 3;
        config.minVisibleCount = newIsDesktop ? 7 : 3;
        setupSlider();
      } else if (config.flowState === 'IDLE') {
        // 只在空闲状态调整位置
        centerActiveItem(false);
      }
    }, 250));
    
    // 防抖函数
    function debounce(func, wait) {
      let timeout;
      return function() {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, arguments), wait);
      };
    }
  }
  
  function mobileCarousel(carousel) {
      carousel.setAttribute('data-is-mobile', 'true');
      
      // 获取基本元素
      const itemsContainer = carousel.querySelector('.joe-five-slider_items'); 
      const items = itemsContainer.querySelectorAll('.joe-five-slider_item');
      const prevButton = carousel.querySelector('.joe-five-slider_prev'); 
      const nextButton = carousel.querySelector('.joe-five-slider_next'); 
      const navBarContainer = carousel.querySelector('.joe-five-slider_nav');
      const navBar = navBarContainer ? navBarContainer.querySelector('.joe-five-slider_nav-bar') : null;
      
      if (!itemsContainer || items.length === 0 || !navBar) {
        console.warn('轮播初始化失败: 缺少必要元素');
        console.log(itemsContainer);
        console.log(items.length);
        console.log(navBar);
        return;
      }

      // 配置和状态
      const config = {
        cardNumber: parseInt(itemsContainer.getAttribute("data-slider-cards")) || 1,
        originalItemsCount: items.length,
        autoplayDelay: parseInt(itemsContainer.getAttribute('data-auto')) || 4000, // 自动轮播间隔
        resumeDelay: 5000,              // 用户交互后恢复自动轮播的延迟(ms)
        transitionDuration: 500,        // 过渡动画时间
        isAnimating: false,
        autoplayTimer: null,
        isAutoplayPaused: false,
        resumeTimeout: null
      };
      
      // 计算滚动距离 - 移动端强制每次滚动一个卡片
      const cardElem = itemsContainer.querySelector('div.joe-five-slider_item');
      if (!cardElem) return;
      
      const cardWidth = cardElem.offsetWidth;
      const gap = parseInt(window.getComputedStyle(itemsContainer).columnGap) || 15; // 移动端gap为15px
      const scrollDistance = cardWidth + gap; // 移动端始终滚动一个卡片的距离
      let currentVideoIndex = 0;
      let isVideoScrolling;
      
      // 初始化无限轮播
      setupInfiniteScroll();
      
      // 初始导航条
      updateNavBar();
      
      // 绑定事件监听
      if (prevButton) {
        prevButton.addEventListener('click', handlePrevClick);
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', handleNextClick);
      }
      
      // 绑定滚动事件
      itemsContainer.addEventListener('scroll', handleScroll, { passive: true });
      
      // 触摸事件 - 开始触摸时暂停，结束触摸后恢复
      itemsContainer.addEventListener('touchstart', () => {
        pauseAutoplay();
      }, { passive: true });
      
      itemsContainer.addEventListener('touchend', () => {
        resumeAutoplayAfterDelay(config.resumeDelay);
      }, { passive: true });
      
      // 开始自动轮播
      startAutoplay();
      
      // 初始检测当前位置
      setTimeout(() => {
        currentVideoIndex = getCurrentItemIndex();
        updateNavBar();
      }, 100);
      
      // ===== 核心功能函数 =====
      
      // 设置无限滚动功能
      function setupInfiniteScroll() {
        // 检查是否已经设置了克隆项
        const clones = itemsContainer.querySelectorAll('.cloned');
        if (clones.length > 0) return; // 已经设置过了
        
        // 复制前面项目到末尾
        Array.from(items).slice(0, 2).forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add('cloned', 'clone-end');
          clone.setAttribute('data-original-index', 
            Array.from(items).indexOf(item));
          itemsContainer.appendChild(clone);
        });
        
        // 复制后面项目到开头
        Array.from(items).slice(-2).reverse().forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add('cloned', 'clone-start');
          clone.setAttribute('data-original-index', 
            Array.from(items).indexOf(item));
          itemsContainer.prepend(clone);
        });
        
        // 设置初始滚动位置(跳过前面的克隆项)
        setTimeout(() => {
          itemsContainer.style.scrollBehavior = 'auto';
          // 使用实际的滚动距离，包含gap
          itemsContainer.scrollLeft = 2 * (cardWidth + gap);
          
          setTimeout(() => {
            itemsContainer.style.scrollBehavior = 'smooth';
          }, 10);
        }, 10);
      }
      
      // 处理前进按钮点击
      function handleNextClick() {
        if (config.isAnimating) return;
        
        pauseAutoplay();
        scrollToNext();
        resumeAutoplayAfterDelay(config.resumeDelay);
      }
      
      // 处理后退按钮点击
      function handlePrevClick() {
        if (config.isAnimating) return;
        
        pauseAutoplay();
        scrollToPrev();
        resumeAutoplayAfterDelay(config.resumeDelay);
      }
      
      // 滚动到下一项 - 优化版本
      function scrollToNext() {
        if (config.isAnimating) return;
        config.isAnimating = true;
        
        // 预先计算目标位置，避免累积误差
        const targetScrollLeft = itemsContainer.scrollLeft + scrollDistance;
        
        itemsContainer.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth'
        });
        
        // 减少延迟时间，提升响应性
        setTimeout(() => {
          checkInfiniteScroll();
          currentVideoIndex = getCurrentItemIndex();
          updateNavBar();
          config.isAnimating = false;
        }, config.transitionDuration - 100); // 减少100ms延迟
      }
      
      // 滚动到上一项 - 优化版本
      function scrollToPrev() {
        if (config.isAnimating) return;
        config.isAnimating = true;
        
        const targetScrollLeft = Math.max(0, itemsContainer.scrollLeft - scrollDistance);
        
        itemsContainer.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth'
        });
        
        setTimeout(() => {
          checkInfiniteScroll();
          currentVideoIndex = getCurrentItemIndex();
          updateNavBar();
          config.isAnimating = false;
        }, config.transitionDuration - 100);
      }
      
      // 检查无限滚动的边界情况 - 优化版本，减少抖动
      function checkInfiniteScroll() {
        const scrollLeft = itemsContainer.scrollLeft;
        const maxScrollLeft = itemsContainer.scrollWidth - itemsContainer.clientWidth;
        const itemWidthWithGap = cardWidth + gap;
        const threshold = itemWidthWithGap * 0.8; // 增加阈值，提前触发
        
        // 如果滚动到最左边的克隆区域
        if (scrollLeft <= threshold) {
          // 使用requestAnimationFrame确保平滑过渡
          requestAnimationFrame(() => {
            itemsContainer.style.scrollBehavior = 'auto';
            const jumpToPosition = scrollLeft + (config.originalItemsCount * itemWidthWithGap);
            itemsContainer.scrollLeft = jumpToPosition;
            
            // 延迟恢复平滑滚动
            requestAnimationFrame(() => {
              itemsContainer.style.scrollBehavior = 'smooth';
            });
          });
        }
        // 如果滚动到最右边的克隆区域
        else if (scrollLeft >= maxScrollLeft - threshold) {
          requestAnimationFrame(() => {
            itemsContainer.style.scrollBehavior = 'auto';
            const jumpToPosition = scrollLeft - (config.originalItemsCount * itemWidthWithGap);
            itemsContainer.scrollLeft = jumpToPosition;
            
            requestAnimationFrame(() => {
              itemsContainer.style.scrollBehavior = 'smooth';
            });
          });
        }
      }
      
      // 获取当前中心项目的索引
      function getCurrentItemIndex() {
        const containerRect = itemsContainer.getBoundingClientRect();
        const containerCenter = containerRect.left + containerRect.width / 2;
        
        let closestCard = null;
        let minDistance = Infinity;
        let closestIndex = 0;
        
        // 获取所有项目，包括克隆项
        const allItems = itemsContainer.querySelectorAll('.joe-five-slider_item');
        
        allItems.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          const distance = Math.abs(containerCenter - cardCenter);
          
          if (distance < minDistance) {
            minDistance = distance;
            closestCard = card;
            closestIndex = index;
          }
        });
        
        // 转换为原始索引
        let originalIndex;
        if (closestCard.classList.contains('cloned')) {
          originalIndex = parseInt(closestCard.getAttribute('data-original-index') || '0');
        } else {
          // 考虑前面克隆的项目
          originalIndex = closestIndex - 2;
          if (originalIndex < 0) {
            originalIndex += config.originalItemsCount;
          }
          originalIndex = originalIndex % config.originalItemsCount;
        }
        
        return originalIndex;
      }
      
      // 更新导航条位置
      function updateNavBar() {
        if (!navBar || !navBarContainer) return;
        
        const navWidth = navBarContainer.scrollWidth;
        const navBarWidth = navWidth / config.originalItemsCount;
        
        navBar.style.width = `${navBarWidth}px`;
        navBar.style.left = `${navBarWidth * currentVideoIndex}px`;
      }
      
      // 处理滚动事件 - 优化版本，减少频繁更新
      function handleScroll() {
        // 清除之前的定时器
        clearTimeout(isVideoScrolling);
        
        // 用户滚动时暂停自动轮播
        if (!config.isAnimating) {
          pauseAutoplay();
        }
        
        // 减少检测延迟，提升响应性
        isVideoScrolling = setTimeout(function() {
          // 仅在非动画状态时处理滚动停止
          if (!config.isAnimating) {
            checkInfiniteScroll();
            const newIndex = getCurrentItemIndex();
            
            // 仅当索引真正改变时才更新UI
            if (newIndex !== currentVideoIndex) {
              currentVideoIndex = newIndex;
              updateNavBar();
            }
            
            // 滚动停止后恢复自动轮播
            resumeAutoplayAfterDelay(config.resumeDelay);
          }
        }, 150); // 减少到150ms，提升响应性
      }
      
      // 自动轮播控制函数
      function startAutoplay() {
        // 清除现有定时器
        stopAutoplay();
        
        // 设置新的定时器
        config.autoplayTimer = setInterval(() => {
          if (!config.isAutoplayPaused && !config.isAnimating) {
            scrollToNext();
          }
        }, config.autoplayDelay);
      }
      
      function stopAutoplay() {
        if (config.autoplayTimer) {
          clearInterval(config.autoplayTimer);
          config.autoplayTimer = null;
        }
      }
      
      function pauseAutoplay() {
        config.isAutoplayPaused = true;
        
        // 清除恢复定时器
        if (config.resumeTimeout) {
          clearTimeout(config.resumeTimeout);
          config.resumeTimeout = null;
        }
      }
      
      function resumeAutoplayAfterDelay(delay) {
        // 清除现有定时器
        if (config.resumeTimeout) {
          clearTimeout(config.resumeTimeout);
        }
        
        // 设置恢复定时器
        config.resumeTimeout = setTimeout(() => {
          config.isAutoplayPaused = false;
        }, delay);
      }
  }
});